(function () {
    window.metaConversionApi = (payload) => {
        // if (!OptanonConsentHelper.areAllCookieFlagsEqualToOne(MetaConversionAPIConstants.optanonGroups)) return;
        //
        // const isHarmonyTest: AllowedURLParamTypes = Utils.getURLParamsAsObject().enableHarmonyTest;
        //
        // try {
        //   fetch(
        //     `${isHarmonyTest ? MetaConversionAPIConstants.devApiEndpoint : MetaConversionAPIConstants.prodApiEndpoint}`,
        //     {
        //       method: "POST",
        //       headers: {
        //         "Content-Type": "application/json"
        //       },
        //       body: JSON.stringify(payload)
        //     }
        //   );
        // } catch (error) {
        //   console.error("Meta Conversion Api error:", error);
        // }
    };
})();
export {};
